<div class="content" style="padding: 30px">
  <div class="grid-container">
    <div class="grid-item" *ngFor="let fun of functions">
      <mat-card class="mat-elevation-z4">
        <mat-card-header>
          <mat-card-title>{{ fun.name }}</mat-card-title>
        </mat-card-header>
        <mat-card-content> </mat-card-content>
        <mat-card-actions>
          <button mat-raised-button [routerLink]="fun.route" appPermissionControl="P146B0001">IR</button>
        </mat-card-actions>
      </mat-card>
    </div>
  </div>
</div>
